import { buildEndPoint } from '@mairistem/tools';

import baseUrl from './base';

export const searchBanques = (
  { query, perPage } = {
    query: '',
    perPage: 10,
  },
) =>
  buildEndPoint(`${baseUrl}/banques/search`, {
    q: query,
    perPage: perPage || 10,
  });

export const getBanque = (id: number) => `${baseUrl}/banques/${id}`;
